import { render, staticRenderFns } from "./DeviceDetailSmConfiguration.vue?vue&type=template&id=22350af3&scoped=true&"
import script from "./DeviceDetailSmConfiguration.vue?vue&type=script&lang=js&"
export * from "./DeviceDetailSmConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./DeviceDetailSmConfiguration.vue?vue&type=style&index=0&id=22350af3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22350af3",
  null
  
)

export default component.exports